$(function () {
  const moengageTracking = {
    init() {
      moengageTracking.create();
    },
    create() {
      // if (!Moengage) return;

      // CategoryClick
      $(document).on("click", "[data-nav] a", function () {
        const self = $(this);
        const category = self.attr("title") || self.find(".txt").text();

        if (category) {
          Moengage.track_event("CategoryClick", {
            Category: category.replace(/\n|\r|\t/g, ""),
          });
        }
      });

      // ServiceClick
      $(document).on(
        "click",
        ".panel.panel-our-services [data-tab-element]",
        function () {
          const self = $(this);
          const service = self.find(".txt").text();

          if (service) {
            Moengage.track_event("ServiceClick", {
              Service: service.replace(/\n|\r|\t/g, ""),
            });
          }
        }
      );

      $(document).on(
        "click",
        ".panel.panel-our-services .box-wrap a",
        function () {
          const self = $(this);
          const service = self.parent().find(".heading").text();

          if (service) {
            Moengage.track_event("ServiceClick", {
              Service: service.replace(/\n|\r|\t/g, ""),
            });
          }
        }
      );

      // FormClick
      $(document).on(
        "click",
        '[data-popup-element=""][data-name="longform_shortform"]',
        function () {
          Moengage.track_event("FormClick", {
            URL: window.location.href,
          });
        }
      );

      $(document).on(
        "click",
        '[data-popup-content=""][data-name="search"] .bottom a',
        function () {
          Moengage.track_event("FormClick", {
            URL: window.location.href,
          });
        }
      );

      $(document).on("click", "footer a", function () {
        if ($(this).attr("href").indexOf("/contact") !== -1) {
          Moengage.track_event("FormClick", {
            URL: window.location.href,
          });
        }
      });

      $(document).on("click", "header .nav .group .btn-link", function () {
        if ($(this).attr("href").indexOf("/contact") !== -1) {
          Moengage.track_event("FormClick", {
            URL: window.location.href,
          });
        }
      });

      // InsightCategoryClick
      $(document).on("click", ".related-insight .tags a", function () {
        const self = $(this);
        const tag = self.text();

        if (tag) {
          Moengage.track_event("InsightCategoryClick", {
            InsightCategory: tag.replace(/\n|\r|\t/g, ""),
          });
        }
      });

      // TagClick
      $(document).on(
        "click",
        ".facetwp-facet-categories .facetwp-checkbox, .facetwp-facet-categories_radio .facetwp-radio",
        function () {
          const self = $(this);
          const tag = self.find(".facetwp-display-value").text();

          if (tag) {
            Moengage.track_event("TagClick", {
              Tag: tag.replace(/\n|\r|\t/g, ""),
            });
          }
        }
      );

      // PopularKeywordsClick
      $(document).on(
        "click",
        "[data-popup-content].w-search .ul-keywords a",
        function () {
          const self = $(this);
          const popularKeyword = self.text();

          if (popularKeyword) {
            Moengage.track_event("PopularKeywordsClick", {
              PopularKeywords: popularKeyword.replace(/\n|\r|\t/g, ""),
            });
          }
        }
      );

      // SearchClick
      $(document).on(
        "click",
        '[data-popup-element=""][data-name="search"]',
        function () {
          Moengage.track_event("SearchClick");
        }
      );

      // RecentSearchs
      $(document).on("click", "[data-recent-search] .ul-recent a", function () {
        const recentSearch = $(this).text();

        if (recentSearch) {
          Moengage.track_event("RecentSearchs", {
            RecentSearchs: recentSearch.replace(/\n|\r|\t/g, ""),
          });
        }
      });

      // TrendingTopicsClick
      $(document).on(
        "click",
        "[data-trending-posts] .ul-recent a",
        function () {
          const trendingTopic = $(this).text();

          if (trendingTopic) {
            Moengage.track_event("TrendingTopicsClick", {
              TrendingTopics: trendingTopic.replace(/\n|\r|\t/g, ""),
            });
          }
        }
      );

      // FillFormComplete
      $(document).bind('gform_post_render', function(event, form_id, current_page){
        const form = $(`#gform_${form_id}`);
        if (form.length && !form.find(".validation_message").length && form.find('input[name="input_3.3"]').val()) {
          Moengage.add_first_name(form.find('input[name="input_3.3"]').val());
          Moengage.add_last_name(form.find('input[name="input_3.6"]').val());
          Moengage.add_email(form.find('input[name="input_5"]').val());
          Moengage.add_mobile(form.find('input[name="input_4"]').val());

          Moengage.add_user_attribute(
            "Company",
            form.find('input[name="input_6"]').val()
          );
          Moengage.add_user_attribute(
            "Title",
            form.find('input[name="input_7"]').val()
          );
          Moengage.add_user_attribute(
            "Industry",
            form.find('select[name="input_8"]').val()
          );
          const services = [];
          form
            .find("#field_5_13")
            .find('input[type="checkbox"]')
            .each(function () {
              const cb = $(this);
              if (cb.is(":checked")) {
                services.push(cb.val());
              }
            });
          form
            .find("#field_1_13")
            .find('input[type="checkbox"]')
            .each(function () {
              const cb = $(this);
              if (cb.is(":checked")) {
                services.push(cb.val());
              }
            });
          form
            .find("#field_2_20")
            .find('input[type="checkbox"]')
            .each(function () {
              const cb = $(this);
              if (cb.is(":checked")) {
                services.push(cb.val());
              }
            });
          Moengage.add_user_attribute("ServiceDetail", services);
          Moengage.add_user_attribute(
            "Others",
            form.find('input[name="input_14"]').val()
          );

          Moengage.track_event("FillFormComplete", {
            FirstName: form.find('input[name="input_3.3"]').val(),
            LastName: form.find('input[name="input_3.6"]').val(),
            Email: form.find('input[name="input_5"]').val(),
            Mobile: form.find('input[name="input_4"]').val(),
            Company: form.find('input[name="input_6"]').val(),
            Tittle: form.find('input[name="input_7"]').val(),
            Industry: form.find('select[name="input_8"]').val(),
            ServiceDetail: services,
            Others: form.find('select[name="input_14"]').val(),
          });

          if (localStorage.getItem("USED_TO_FILLED")) {
            Moengage.update_unique_user_id(
              form.find('input[name="input_5"]').val()
            );
          } else {
            Moengage.add_unique_user_id(
              form.find('input[name="input_5"]').val()
            );
            localStorage.setItem("USED_TO_FILLED", 1);
          }
        }
      });

      // gtag
      $(document).on("gform_confirmation_loaded", function (e, form_id) {
        const form = $(`#gf_${form_id}`);
        if (form.length && window.gtag) {
          const entry =  form.parent().find("[data-entry-id]");

          gtag("event", "form_complete", {
            send_to: window?.talentnet?.gtag,
            user_id : entry.data("entry-id")
          });

          const form_type = entry.data("form-complete");
          const services = entry.data("services");
          const industry = entry.data("industry");
          const service_location = entry.data("service-location");
          const remark = entry.data("remark");
          const additionalTrackingData = {
            form_type,
            services,
            industry,
            service_location,
            remark: !!remark
          };

          gtag("event", "form_complete_v2", {
            send_to: window?.talentnet?.gtag,
            user_id : entry.data("entry-id"),
            ...additionalTrackingData
          });
        }
      });
    },
  };

  moengageTracking.init();
});
